import React, { useState, useEffect } from 'react';
import Entities, {XmlEntities} from 'html-entities';
import BlockDisplay from './BlockDisplay';
import { Input, Popover } from 'antd';
 
const entities = new XmlEntities();

function FullFeature({setCodeBlock}) {
  const [heading, setHeading] = useState("Tinseltown Elegance 101");
  const [text, setText] = useState("Created for Nicole Kidman to wear in her starring role in HBO’s “Big Little Lies,” the Celeste Charm Necklace is an eye-catching statement piece.");
  const [buttonText, setButtonText] = useState("Shop Celeste");
  const [link, setLink] = useState("https://artisan-default-demo.mybigcommerce.com/personalized-jewelry/");
  const [image, setImage] = useState("https://cdn11.bigcommerce.com/s-aas6vytuee/product_images/uploaded_images/full-feature.png");
  const tooltip = (
    <div>
      <span>To accomplish the same effect as the demo store, please use these dimensions.</span>
    </div>
  );

  const codeBlock = `<div class="feature-full">
  <a href="${entities.encode(link)}"><img src="${entities.encode(image)}"></a>
  <div class="container feature-full-text">
      <h2>${entities.encode(heading)}</h2>
      <p>${entities.encode(text)}</p>
      <a href="${entities.encode(link)}" class="button">${entities.encode(buttonText)}</a>
  </div>
</div>`;

  useEffect(() => {
    setCodeBlock(codeBlock);
  }, [codeBlock]);

  return (
    <div className="singleBlock">
      <div className="sidebar">
        <h2>Full Feature Block</h2>
        <label>
          <span>Image&nbsp;
            <Popover content={tooltip}>
              <a href="javascript:void(0)">(Width: 1440px - Height: 800px)</a>
            </Popover>
          </span>
          <Input type="text" value={image} onChange={(evt) => setImage(evt.target.value)} />
        </label>
        <label>
          <span>Heading</span>
          <Input type="text" value={heading} onChange={(evt) => setHeading(evt.target.value)} />
        </label>
        <label>
          <span>Text</span>
          <Input type="text" value={text} onChange={(evt) => setText(evt.target.value)} />
        </label>
        <label>
          <span>Button Text</span>
          <Input type="text" value={buttonText} onChange={(evt) => setButtonText(evt.target.value)} />
        </label>
        <label>
          <span>Link</span>
          <Input type="text" value={link} onChange={(evt) => setLink(evt.target.value)} />
        </label>
      </div>
      <BlockDisplay codeBlock={codeBlock}/>
    </div>
  )
}

export default FullFeature;
